module.exports = __webpack_public_path__ + "media/images/flags/mn-5d695f22edcdfb6224eabdf9841f91a5.svg";